var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignTimingIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33337 2.07692C4.06215 2.07692 1.4103 4.72877 1.4103 8C1.4103 11.2712 4.06215 13.9231 7.33337 13.9231C10.6046 13.9231 13.2565 11.2712 13.2565 8C13.2565 4.72877 10.6046 2.07692 7.33337 2.07692ZM0.333374 8C0.333374 4.13401 3.46738 1 7.33337 1C11.1994 1 14.3334 4.13401 14.3334 8C14.3334 11.866 11.1994 15 7.33337 15C3.46738 15 0.333374 11.866 0.333374 8ZM7.33337 3.87179C7.63076 3.87179 7.87184 4.11287 7.87184 4.41026V7.77696L9.86797 9.7731C10.0783 9.98338 10.0783 10.3243 9.86797 10.5346C9.65769 10.7449 9.31675 10.7449 9.10647 10.5346L6.95262 8.38075C6.85164 8.27977 6.79491 8.14281 6.79491 8V4.41026C6.79491 4.11287 7.03599 3.87179 7.33337 3.87179Z",
    fill: "#7043FF",
    stroke: "#7043FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignTimingIconPurple);
export default __webpack_public_path__ + "static/media/campaign_timing_icon_purple.0725e2762a625325a605354981a7b72d.svg";
export { ForwardRef as ReactComponent };